import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useState } from "react";
import { toast, Bounce } from "react-toastify";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface Props {
  show: boolean;
  onHide: () => void;
  onSuccess: () => void;
}

export default function AddOEMModal({ show, onHide, onSuccess }: Props) {
  const [supplier, setSupplier] = useState({
    legal_name: "",
    email: "",
    phone: "",
    trade_name: "",
    rc_number: "",
    nif: "",
    nis: "",
    address: "",
    wilaya: "",
    website: "",
    workforce_total: 0,
    industrial_status: "active",
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setSupplier((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");

      const res = await fetch(`${backendUrl}/api/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...supplier,
          id_user: user.id_user,
          geo_lat: null,
          geo_lng: null,
          maturity_score: 0,
        }),
      });

      if (!res.ok) {
        const errorText = await res.text();
        toast.error("Error: " + errorText, { transition: Bounce });
        return;
      }

      toast.success("Supplier created", { transition: Bounce });

      onHide();
      onSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Add Supplier</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row>
            {/* LEFT COLUMN */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Legal Name</Form.Label>
                <Form.Control name="legal_name" onChange={handleChange} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  name="email"
                  type="email"
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control name="phone" onChange={handleChange} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Trade Name</Form.Label>
                <Form.Control name="trade_name" onChange={handleChange} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>RC</Form.Label>
                <Form.Control name="rc_number" onChange={handleChange} />
              </Form.Group>

              {/* ✅ MOVE STATUS HERE */}
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select name="industrial_status" onChange={handleChange}>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {/* RIGHT COLUMN */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>NIF</Form.Label>
                <Form.Control name="nif" onChange={handleChange} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>NIS</Form.Label>
                <Form.Control name="nis" onChange={handleChange} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control name="address" onChange={handleChange} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Wilaya</Form.Label>
                <Form.Control name="wilaya" onChange={handleChange} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Website</Form.Label>
                <Form.Control name="website" onChange={handleChange} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Workforce</Form.Label>
                <Form.Control
                  type="number"
                  name="workforce_total"
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>

        <Button variant="warning" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
